import { z } from "zod";
import { integrationProviderSchema } from "./provider.js";
import { integrationTestStatusSchema } from "./test-status.js";
export const integrationStatusSchema = z.object({
    provider: integrationProviderSchema,
    connected: z.boolean(),
    last_tested_at: z.number().nullable(),
    last_test_status: integrationTestStatusSchema.nullable(),
    masked_key: z.string().nullable(),
    publishable_key: z.string().nullable().optional(),
    from_email: z.string().nullable().optional(),
    webhook_url: z.string(),
});
